module.exports = __webpack_public_path__ + "static/media/image6.e2a33828.png";